import { createFileRoute } from '@tanstack/react-router';
import { OAuthCallbackPage } from '@/features/email-connections';

// Google and Microsoft redirect the connect popup here. It sits outside /_dashboard so the popup
// shows a compact result card instead of the whole app; the page itself waits for the Clerk
// session and posts as that user, so the API can check that this user started the connect.
export const Route = createFileRoute('/oauth/callback/$provider')({
  component: OAuthCallbackRoute,
});

function OAuthCallbackRoute() {
  const { provider } = Route.useParams();
  return <OAuthCallbackPage provider={provider} />;
}
